import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function LocationsRoute() {

    const { path } = useRouteMatch();
    
    return (
        <>
            <Switch>
                <Route path={`${path}`} exact>
                    <Pages.LocationsPage />
                </Route>
                <Route path={`${path}/create`} exact>
                    <Pages.LocationCreatePage />
                </Route>
                <Route path={`${path}/page/:id`} exact>
                    <Pages.LocationsPage />
                </Route>
                <Route path={`${path}/:id`}>
                    { ( { match, history } ) => <Pages.LocationEditPage match={ match } history={ history }/> }
                </Route>
            </Switch>
        </>
    );

}